module.exports = __webpack_public_path__ + "img/emoji-36.02374960.png";